// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".error-ops{font-weight:700;line-height:54px}.error-description{font-weight:300;line-height:24px;font-size:24px}@media (max-width:630px){.error-description{font-size:18px}}.error-image{margin-left:135px}@media (max-width:899px){.error-image{margin:0}}.size-icon{width:36px;height:36px;padding-bottom:6px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
